/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { memo } from 'react';
import { Box, Grid } from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroll-component';

import ShortVideoCard from '../ShortVideoCard/ShortVideoCard';
import ShortVideoCardSkeleton from '../ShortVideoCardSkeleton/ShortVideoCardSkeleton';
// styles
import './ShortVideoList.css';

function ShortVideoList({
  isShortVideoLoading,
  shortVideosList,
  fetchMoreShortVideos,
  hasMoreVideos,
  navigateToShortVideoPage,
  isUserPrivate,
  shortVideosPrivacy,
  userNickName,
}) {
  return (
    <>
      <span className='short-videos-label'>Short Videos</span>
      <Box className='short-videos-main-container'>
        {isShortVideoLoading
          ? <ShortVideoCardSkeleton />
          : (
            <>
              {shortVideosList && shortVideosList.length > 0 && (
                <InfiniteScroll
                  dataLength={shortVideosList.length}
                  next={fetchMoreShortVideos}
                  loader={<ShortVideoCardSkeleton />}
                  hasMore={hasMoreVideos}
                  endMessage={(
                    <p style={{ textAlign: 'center' }}>
                      <b />
                    </p>
                  )}
                >
                  <Grid container className='short-videos-container'>
                    {shortVideosList.map((videoItem, _index) => (
                      <ShortVideoCard
                        key={videoItem.feed_id}
                        videoItem={videoItem}
                        navigateToShortVideoPage={navigateToShortVideoPage}
                      />
                    ))}
                  </Grid>
                </InfiniteScroll>
              )}
              {isUserPrivate && (
                <p className='short-video-privacy'>{shortVideosPrivacy}</p>
              )}
              {!isUserPrivate && shortVideosList && shortVideosList.length === 0 && (
                <p className='short-video-empty'>
                  {`${userNickName} hasn't posted anything to their feed.`}
                </p>
              )}
            </>
          )}
      </Box>
    </>
  );
}
export default memo(ShortVideoList);
